import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@common/http/query-client';
import { CustomNotification } from '@app/admin/notifications/custom-notification';
import { BackendResponse } from '@common/http/backend-response/backend-response';

interface ActiveNotificationsResponse extends BackendResponse {
    notifications: CustomNotification[];
}

export function useActiveNotifications() {
    return useQuery({
        queryKey: ['custom-notifications', 'active'],
        queryFn: () =>
            apiClient
                .get<ActiveNotificationsResponse>('custom-notifications/active')
                .then(r => r.data),
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
}
